module.exports = __webpack_public_path__ + "static/media/500.af3b1c52.png";